import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { DAO } from '../../../modal/DAO';
import { DatePipe } from '@angular/common';
import { ServiceLayer } from 'src/app/services/serviceLayer';
declare var $: any;

@Component({
  selector: 'app-cancel-policy-popup',
  templateUrl: './cancel-policy-popup.component.html',
})
export class CancelPolicyPopUp implements OnInit {

  constructor( public dao: DAO,public datepipe:DatePipe,private serviceLayer:ServiceLayer) { }
  public IsCancelOCP:boolean=false;
  @Input() IsCancel:boolean=false;
  @Input() policyReasons:any;
  @Output() pushCancelDetails = new EventEmitter<any>();
  @Input() cancelDetails:any={};
  @Input() policyDetails:any;
  @Output() popupEvent = new EventEmitter<any>();
  public policyTerm:any;
  public reasonDropdown:any=[];
  public effectiveDate:any;
  public ocpNumber:any;
  public maxDate:Date;
  public minDate:Date;
  public reasonerror:boolean=false;
  public dateerror:boolean=false;  
  public acknowledge:boolean = false;
  public isConfirmCancel:boolean = false;  
  public isClaimFound:boolean = false;
  public isPendingAmendment:boolean = false;
  @Input() currentPolicy:any;
  @Input() cancelPopupDetails:any;  
  public premiumAmount:string='';
  public totalPremiumAmount:string='';
  showCancelPolicyLockPopup = false;
  policyLockMessage = '';
  ngOnInit(): void {
    this.openPopup();
    this.maxDate = new Date(this.policyDetails.expireDate);
    this.minDate = new Date(new Date().setDate(new Date().getDate() - 45));
    if(this.minDate <= new Date(this.policyDetails.effectiveDate)){
      this.minDate = new Date(this.policyDetails.effectiveDate)
    }
  }

  changeReason() {
    if(this.dao.closedPopupModel.cancelReasonCdModal != null) {
      this.reasonerror = false;
    }
    else {
      this.reasonerror = true;
    }
  }

  async getReason() {
    let response = await this.serviceLayer.getCancelReasonDetails();
    if(response != undefined && response.popupInputObj != undefined) {
      this.reasonDropdown = response.popupInputObj;
    }
  }
  openPopup(){
    $("#cancelModal").modal('show');
  }
  async confirmCancel(){
    if(this.acknowledge) {
      if(this.dao.closedPopupModel.cancelReasonCdModal != null) {
        this.reasonerror = false;
        if(this.dao.closedPopupModel.cancelOCP) {
          if(this.ocpNumber != undefined && this.ocpNumber != null) {
            this.policyDetails['cancellationEffectiveDate'] = this.datepipe.transform(this.effectiveDate,"MM/dd/yyyy");
            this.policyDetails['ocpPolicyNumber'] = this.ocpNumber;
            this.policyDetails['totalPremiumAmount'] = this.totalPremiumAmount;
            await this.pushCancelDetails.emit(this.policyDetails);
            this.isConfirmCancel = false;
          }
          else {
            this.dao.closedPopupModel.isShowError = true;
            this.dao.closedPopupModel.errorMsg = "Please provide your OCP policy number";
          }
        }
        else {
          this.policyDetails['cancellationEffectiveDate'] = this.datepipe.transform(this.effectiveDate,"MM/dd/yyyy"); 
          this.policyDetails['ocpPolicyNumber'] = this.ocpNumber;
          this.policyDetails['totalPremiumAmount'] = this.totalPremiumAmount;
          await this.pushCancelDetails.emit(this.policyDetails);
          this.isConfirmCancel = false;
        }
      }
      else {
        this.reasonerror = true;
      }
    }
  }
  close(){
    this.dao.closedPopupModel.isShowError = false;
    this.dao.closedPopupModel.cancelReasonCdModal = null;
    this.dao.closedPopupModel.cancelOCP = false;
    this.popupEvent.emit(this.policyDetails);
  }
  closePolicyLockPopup() {
  this.showCancelPolicyLockPopup = false;
  this.close(); // use existing close logic

}
  async calculateChange(){
    this.reasonerror = false;
    this.dateerror = false;
    if(this.dao.closedPopupModel.cancelReasonCdModal != null && this.effectiveDate != null) {
      this.currentPolicy.isClaimFound = this.isClaimFound;
      this.currentPolicy.isPendingAmendment = this.isPendingAmendment;
      this.currentPolicy['cancellationEffectiveDate'] = this.datepipe.transform(this.effectiveDate,"MM/dd/yyyy");
      this.currentPolicy['ocpPolicyNumber'] = this.ocpNumber;
      this.currentPolicy['referenceNumber'] = this.policyDetails?.referenceNumber === '' ? null : this.policyDetails?.referenceNumber;
      this.currentPolicy['productCode'] = this.policyDetails?.productCode;
      this.currentPolicy['nameInsured'] = this.policyDetails?.nameInsured;
      this.currentPolicy['policyMod'] = this.policyDetails?.policyMod;
      var element = document.getElementById("UpdateID");
      if(element != undefined && element != null) {
        element.classList.add("calculateLbl");
      }
      let response:any = await this.serviceLayer.cancelationDetail(this.cancelPopupDetails, this.currentPolicy,true,0);
        if (response?.messageStatus?.toUpperCase() === 'ERROR') {
            this.policyLockMessage = response?.messageStatusDescription;
            this.showCancelPolicyLockPopup = true;
            return;
        }
      if(element != undefined && element != null) {
        element.classList.remove("calculateLbl");
      }
      this.premiumAmount = response?.returnedPremium;
      this.totalPremiumAmount = response?.totalWrittenPremium;
      if(!this.dao.closedPopupModel.isShowError){
        this.isConfirmCancel = true;
      }
      else {
        this.dao.showErrorPopup = true;
      }  
    }
    else{
      this.reasonerror = this.dao.closedPopupModel.cancelReasonCdModal == null;
      this.dateerror = this.effectiveDate == null;
    }
  }
  async getClaimAndPendingAmendFound(){
    this.isPendingAmendment = false; 
    this.isClaimFound = false;
    if(this.policyDetails && this.policyDetails.claimDetails && this.policyDetails.claimDetails.length > 0 && this.policyDetails.claimDetails.filter(c=>c.status == 'Open').length > 0){
      this.isClaimFound = true;
    }
    if(this.policyDetails && this.policyDetails.numberOfPendingAmendments != undefined && this.policyDetails.numberOfPendingAmendments != '' && Number(this.policyDetails.numberOfPendingAmendments) > 0){
      this.isPendingAmendment = true; 
    }
  }
}
